import { render, staticRenderFns } from "./datasubject-transfering-form.vue?vue&type=template&id=616bb4fd&scoped=true"
import script from "./datasubject-transfering-form.vue?vue&type=script&lang=js"
export * from "./datasubject-transfering-form.vue?vue&type=script&lang=js"
import style0 from "./datasubject-transfering-form.vue?vue&type=style&index=0&id=616bb4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bb4fd",
  null
  
)

export default component.exports